const NPI_CARD_ISSUER_PREFIX = "80840";

export const NPI_ERROR_MESSAGE =
  "Enter the 10-digit NPI exactly as issued; this one fails its check digit.";

export const normaliseNpi = (value: string): string =>
  value.replace(/\s+/g, "");

const passesLuhn = (digits: string): boolean =>
  [...digits].reverse().reduce((total, char, index) => {
    const digit = Number(char);
    if (index % 2 === 0) return total + digit;
    const doubled = digit * 2;
    return total + (doubled > 9 ? doubled - 9 : doubled);
  }, 0) %
    10 ===
  0;

export const isValidNpi = (value: string): boolean => {
  const npi = normaliseNpi(value);
  return /^\d{10}$/.test(npi) && passesLuhn(`${NPI_CARD_ISSUER_PREFIX}${npi}`);
};
